var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSort = function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M2 6.4C2 5.627 2.64 5 3.429 5H20.57C21.361 5 22 5.627 22 6.4s-.64 1.4-1.429 1.4H3.43C2.639 7.8 2 7.173 2 6.4M2 12c0-.773.64-1.4 1.429-1.4h11.904c.79 0 1.429.627 1.429 1.4s-.64 1.4-1.429 1.4H3.43C2.639 13.4 2 12.773 2 12m0 5.6c0-.773.64-1.4 1.429-1.4h7.619c.789 0 1.428.627 1.428 1.4s-.64 1.4-1.428 1.4h-7.62C2.64 19 2 18.373 2 17.6",
    clipRule: "evenodd"
  })));
};
export default SvgSort;